module.exports = __webpack_public_path__ + "static/media/empty-calendar.1cc5319e.svg";